import { useNavigate } from 'react-router-dom';

export default function MojeSkupinyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px 20px 100px 20px' }}>
      {/* Back button */}
      <button
        onClick={() => navigate('/profile')}
        style={{
          background: 'none',
          border: 'none',
          color: '#667eea',
          fontSize: '15px',
          fontWeight: 500,
          cursor: 'pointer',
          marginBottom: '16px',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Späť na profil
      </button>

      <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#111827', marginBottom: '8px' }}>
        Moje skupiny
      </h1>
      <p style={{ fontSize: '15px', color: '#6b7280', marginBottom: '24px' }}>
        Spravuj si zoznam ľudí pre rozdeľovanie bločkov. A čoskoro pribudnú aj ďalšie možnosti.
      </p>

      {/* Group types cards */}
      <div style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        overflow: 'hidden'
      }}>
        <GroupTypeCard
          emoji="👥"
          title="Ľudia, s ktorými rozdeľuješ bločky"
          description="Spravuj zoznam ľudí, s ktorými najčastejšie rozdeľuješ bločky"
          available={true}
          onClick={() => navigate('/profile/moje-skupiny/moji-ludia')}
        />
        {/* Future features - hidden for now
        <GroupTypeCard
          emoji="👨‍👩‍👧‍👦"
          title="Rodinná skupina"
          description="🚧 Pripravujeme spoločné rozpočty a štatistiky pre rodinu"
          available={false}
        />
        <GroupTypeCard
          emoji="🔗"
          title="Splitwise prepojenie"
          description="🚧 Pripravujeme synchronizáciu so Splitwise"
          available={false}
        />
        */}
      </div>
    </div>
  );
}

interface GroupTypeCardProps {
  emoji: string;
  title: string;
  description: string;
  available: boolean;
  onClick?: () => void;
}

function GroupTypeCard({ emoji, title, description, available, onClick }: GroupTypeCardProps) {
  return (
    <div
      onClick={available ? onClick : undefined}
      style={{
        padding: '16px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        opacity: available ? 1 : 0.5,
        cursor: available ? 'pointer' : 'not-allowed',
        transition: 'background 0.2s',
        background: 'transparent'
      }}
      onMouseEnter={(e) => {
        if (available) e.currentTarget.style.background = '#f9fafb';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '15px', fontWeight: 500, color: '#111827', marginBottom: '2px' }}>
          <span style={{ marginRight: '6px' }}>{emoji}</span>
          {title}
        </div>
        <div style={{ fontSize: '13px', color: '#6b7280' }}>
          {description}
        </div>
      </div>
      {available && (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
          <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </div>
  );
}
